export default __webpack_public_path__ + "static/media/sparkoflife.e64ad2a3.png";